import { selectRelatedForms } from './selectRelatedForms';
import { createSelector } from 'reselect';

export const selectFormIds = createSelector(
  (state) => state['form'],
  (form) => selectRelatedForms(form),
  (form) => Object.keys(form)
);
